<template>
  <BaseDialog
    :showCondition="resetPasswordDialogState.show"
    @closed="changeResetPasswordDialogState(false)"
  >
    <template v-slot:title>
      <span class="primary--text">تعيين كلمة السر الجديدة</span>
    </template>

    <template v-slot:body>
      <v-form ref="form">
        <v-container>
          <v-row justify="center">
            <v-col align="center" cols="9">
              <div class="text-body-1 mb-5">
                تم إرسال رمز التحقق إلى رقم هاتفك عبر الواتساب
              </div>

              <BaseTextField
                v-model="token"
                class="mt-3"
                label="رمز التحقق"
                placeholder="أدخل رمز التحقق"
                name="رمز التحقق"
                :rules="[requiredRule]"
              >
              </BaseTextField>

              <BasePasswordField
                v-model="password"
                class="mt-3"
                label="كلمة السر الجديدة"
                placeholder="أدخل كلمة السر الجديدة"
                name="كلمة السر الجديدة"
                :rules="[requiredRule, passwordRule]"
                @input="validatePasswordMatch"
              >
              </BasePasswordField>

              <BasePasswordField
                v-model="passwordConfirmation"
                class="mt-3"
                label="تأكيد كلمة السر"
                placeholder="أدخل تأكيد كلمة السر"
                name="تأكيد كلمة السر"
                :rules="[requiredRule, passwordMatchRule]"
                :error-messages="passwordMatchError"
                @input="validatePasswordMatch"
              >
              </BasePasswordField>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </template>

    <template v-slot:actions>
      <v-row justify="center">
        <v-col align="center">
          <v-row justify="space-around">
            <v-btn
              @click="validateThenResetPassword()"
              class="accent rounded-pill px-10 mb-5"
              :loading="loading"
            >
              تعيين كلمة السر
            </v-btn>
            <v-btn
              text
              outlined
              rounded
              @click="changeResetPasswordDialogState(false)"
              class="primary--text mb-5"
            >
              إلغاء
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/core/base/dialogs/BaseDialog.vue";
import { mapState, mapActions } from "pinia";
import { useAuthStore } from "../store/AuthStore";

export default {
  name: "ResetPasswordDialog",
  components: { BaseDialog },
  data() {
    return {
      token: "",
      password: "",
      passwordConfirmation: "",
      loading: false,
      passwordMatchError: "",
    };
  },
  computed: {
    ...mapState(useAuthStore, ["resetPasswordDialogState"]),
    passwordMatchRule() {
      return (v) => {
        if (!v) return "كلمة السر مطلوبة";
        if (v !== this.password) return "كلمات السر غير متطابقة";
        return true;
      };
    }
  },
  methods: {
    ...mapActions(useAuthStore, [
      "changeResetPasswordDialogState",
      "resetPassword",
      "changeLoginDialogState",
    ]),
    validatePasswordMatch() {
      if (this.passwordConfirmation && this.password !== this.passwordConfirmation) {
        this.passwordMatchError = "كلمات السر غير متطابقة";
      } else {
        this.passwordMatchError = "";
      }
    },
    async validateThenResetPassword() {
      this.validatePasswordMatch();
      if (this.$refs.form.validate() && !this.passwordMatchError) {
        this.loading = true;
        try {
          await this.resetPassword({
            phone_number: this.resetPasswordDialogState.phoneNumber,
            token: this.token,
            password: this.password,
          });
          this.changeResetPasswordDialogState(false);
          this.changeLoginDialogState(true, true);
          this.$store.dispatch(
            "showSuccessSnackbar",
            "تم تغيير كلمة السر بنجاح"
          );
        } catch (error) {
          console.error("Error resetting password:", error);
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped></style>
